<template>
    <div id="JobKpiTeamlead" class="row">
        <div class="w-100">
            <div id="panel-1" class="panel mt-1 m-2">
                <div class="m-2">
                    <div class="row m-2">
                        <div class="col-xl-2 col-md-2 col-sm-6">
                            <label><b>Tên/Mã nhân sự</b></label>
                            <div class="form-group w-100">
                                <el-input v-model="query.keyword" class="shadow-sm" clearable placeholder="Nhập tên, sđt, email" type="text"></el-input>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-2 col-sm-6">
                            <label><b>Thời gian</b></label><br>
                            <el-date-picker
                                v-model="query.month"
                                :clearable="false"
                                class="btn-outline-secondary rounded w-100"
                                placeholder="Chọn tháng"
                                size="small"
                                type="month"
                                value-format="yyyy-MM"
                            >
                            </el-date-picker>
                        </div>
                        <div class="col-xl-2 col-md-2 col-sm-6">
                            <label><b>Đơn vị</b></label>
                            <el-select v-model="query.department_id" class="w-100" clearable filterable
                                       placeholder="Chọn đơn vị">
                                <el-option
                                    v-for="(item, index) in allDepartment"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-xl-2 col-md-2 col-sm-6">
                            <label><b>Trạng thái</b></label><br>
                            <el-select v-model="query.status" class="w-100" clearable placeholder="Chọn trạng thái">
                                <el-option
                                    v-for="(item, index) in statusScoreKpi"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.id">
                                    <span style="float: left">{{ item.name }}</span>
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-xl-2 col-md-2 col-sm-6">
                            <button :disabled='loading' class="btn btn-primary mr-2 mt-4" style="background-color: #472f92;"
                                    @click="search">
                                <i class="mr-1 text-white"
                                   v-bind:class="[loading ? 'el-icon-loading' : 'el-icon-search']"></i>Tìm kiếm
                            </button>
                        </div>
                    </div>
                    <div>
                        <div class="card-body">
                            <div class="example mb-10">
                                <div class="row filter_form">
                                </div>
                                <div class="example-preview table-responsive overflow-auto mt-3">
                                    <table
                                        v-loading="loading"
                                        class="table text-left table-hover table-bordered table-vertical-center b-table" element-loading-text="Loading...">
                                        <thead>
                                        <tr style="background-color: #F8F8F8;">
                                            <th>Tên nhân sự</th>
                                            <th>Mã nhân sự</th>
                                            <th>Đơn vị</th>
                                            <th>% KPI tổng</th>
                                            <th>Điểm họp tuần</th>
                                            <th>Người chấm</th>
                                            <th>Trạng thái</th>
                                            <th class="text-center" style="width:150px">Hành động</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in dataKpiPersonal" :key="index">
                                            <td>{{ item?.user?.name ?? '' }}</td>
                                            <td>{{ item.user?.id + 100000 ?? '' }}</td>
                                            <td>{{ item?.department?.name ?? '' }}</td>
                                            <td>
                                                <div :class="{'text-success': item?.total_point_kra > 90, 'text-danger': item?.total_point_kra < 90  }">
                                                    {{ item.total_point_kra ? item.total_point_kra + '%' : 'Chưa có' }}
                                                </div>
                                            </td>
                                            <td>
                                                <div :class="{'text-success': item?.total_point_meeting  > 0, 'text-danger': item?.total_point_meeting <= 0  }">
                                                    {{ item.total_point_meeting ? item.total_point_meeting : 'Chưa có' }}
                                                </div>
                                            </td>
                                            <td>{{ item.assessor ? item?.assessor?.name : '' }}</td>
                                            <td>
                                                <div>
                                                    <span :style="statusKpiCss[ item.total_point_kra && item.total_point_meeting ? '11' : item.status]"
                                                           class="text-white rounded p-2 text-center"
                                                           style="text-align:center">{{ item.total_point_kra && item.total_point_meeting ? 'Đã chấm' :  statusKpi[item.status]  }}
                                                    {{ +item.status === 1 && !item.total_point_kra ? ': KPI' : '' }}
                                                        {{ +item.status === 1 ? (item.total_point_kra ? (!item.total_point_meeting ? ':': '') : (!item.total_point_meeting ? ',': '')) : '' }}
                                                    {{ +item.status === 1 &&  !item.total_point_meeting ? 'Điểm họp tuần' : '' }}
                                                    </span>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <button class="btn btn-outline-primary p-0 mr-2"
                                                        title="Thêm 1 KRA cho nhân sự"
                                                        type="button" @click="createKra(item)">
                                                    <i class="el-icon-document-add p-2"></i>
                                                </button>
                                                <button v-if="+item.status === 2" class="btn btn-outline-primary p-0 mr-2"
                                                        title="Xem" type="button"
                                                        @click="dialogKpiPersonal(true, item)"><i
                                                    class="el-icon-view p-2"></i></button>
                                                <button v-else class="btn btn-outline-warning p-0 mr-2" title="Chấm"
                                                        type="button" @click="dialogKpiPersonal(false, item)">
                                                    <i class="el-icon-edit p-2"></i></button>
                                                <button
                                                    class="btn btn-outline-secondary p-0"
                                                    title="Lịch sử chỉnh sửa"
                                                    type="button" @click="showHistory(item)"
                                                ><i class="el-icon-timer p-2"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="position-absolute mt-3" style="right: 40px;"> Tổng số bản ghi: <b
                                    style="color: rgb(54, 153, 255);">{{
                                        totalData ? totalData : 0
                                    }}</b></div>
                            </div>
                        </div>
                        <div class="edu-paginate mx-auto d-flex justify-content-center">
                            <paginate v-model="page" :click-handler="clickCallback" :container-class="'pagination b-pagination'" :margin-pages="1"
                                      :next-class="'page-link'"
                                      :next-link-class="'next-link-item'" :next-text="'Sau'"
                                      :page-class="'page-item'" :page-count="last_page"
                                      :page-range="3" :pageLinkClass="'page-link'"
                                      :prev-class="'page-link'"
                                      :prev-link-class="'prev-link-item'" :prev-text="'Trước'">
                            </paginate>
                        </div>
                    </div>
                    <el-dialog
                        :title="'Chấm KPI nhân sự:'+ ' ' +user_name_detail"
                        :visible.sync="show_score_kpi"
                        top="2%"
                        width="99%"
                    >
                        <scoreKpi
                            :dataPersonal="dataPersonal"
                            :is_disable="action"
                            :payload="payload"
                            @closeDialog="show_score_kpi=false"
                            @openDialog="handleDialogConfirm"
                        >
                        </scoreKpi>
                    </el-dialog>
                    <el-dialog
                        :visible.sync="show_dialog_confirm"
                        class="dialog-comfirm-score"
                        style="border-radius: 15%"
                        title="Chấm điểm nhân sự"
                        top="30vh"
                        width="25%"
                    >
                        <dialogConfirmScore
                            :dataPersonal="dataPersonal"
                            :department="department_id"
                            :month="query.month"
                            :user_id="user_update"
                            @closeDialog="handleAction"
                        ></dialogConfirmScore>
                    </el-dialog>
                    <el-dialog
                        v-if="isCreateKra"
                        :visible.sync="isCreateKra"
                        class="dialog-comfirm-score"
                        style="border-radius: 15%"
                        title="Thêm KRA cho nhân sự"
                        width="40%" destroy-on-close
                    >
                        <hr style="border: solid 1px lightgray"/>
                        <FormCreateKra
                            :user-info="userSelected"
                            @closeDialog="isCreateKra = false"
                            @getListKra="getDataKpiPersonal"
                        />
                    </el-dialog>
                    <el-dialog
                        v-if="isShowHistory"
                        :visible.sync="isShowHistory"
                        class="dialog-comfirm-score"
                        style="border-radius: 15%"
                        title="Lịch sử thay đổi"
                        width="60%" destroy-on-close
                    >
                        <hr style="border: solid 1px lightgray"/>
                        <DialogHistory :user-info="userSelected"/>
                    </el-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {GET_DEPARTMENT_BY_DEPARTMENT_HEAD} from "@/core/services/store/profile.module";
import scoreKpi from "../TeamLead/component/ScorePersionalComponent.vue";
import dialogConfirmScore from "./component/dialogConfirmScore.vue";
import {GET_DATA_DETAIL_KPI, GET_DATA_KPI_PERSIONAL} from "@/core/services/store/kpi/kpi.module";
import {mapGetters} from "vuex";
import FormCreateKra from "./component/FormCreateKra.vue";
import DialogHistory from "./component/DialogHistory.vue";

export default {
    components: {
        DialogHistory,
        FormCreateKra,
        scoreKpi, dialogConfirmScore
    },
    data() {
        return {
            page: 1,
            last_page: 1,
            month: '',
            totalData: '',
            loading: '',
            show_dialog_confirm: false,
            sum_result_kip: 100,
            sum_score_week: 5,
            allDepartment: [],
            payload: '',
            dataPersonal: [],
            dataKpiPersonal: [],
            loadingSearch: false,
            is_tbp: false,
            show_score_kpi: false,
            action: false,
            user_update: '',
            user_name_detail: '',
            department_id: '',
            query: {
                keyword: '',
                month: '',
                unit: '',
                status: '',
            },
            statusKpiCss: {
                0: "background-color: rgba(255, 0, 0, 1); text-white",
                1: "background-color: rgba(18, 0, 219, 1); text-white",
                2: "background-color: rgba(0, 128, 13, 1); text-white",
                11: "background-color: rgba(0, 128, 13, 1); text-white",
            },
            statusKpi: {
                0: "Chưa nhập thành phẩm",
                1: "Cần chấm",
                2: "Đã chấm",
            },
            statusScoreKpi: [
                {id: 0, name: 'Chưa nhập thành phẩm'},
                {id: 1, name: 'Cần chấm'},
                {id: 2, name: 'Đã chấm'},
            ],
            isCreateKra:  false,
            userSelected: null,
            isShowHistory: false,
        }
    },
    computed: {
        ...mapGetters(['currentUser'])
    },
    mounted() {
        this.getMonthCurrent();
        this.getDepartmentByUserId(this.currentUser.id);
        this.getDataKpiPersonal();
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Chấm điểm KPI nhân sự", icon: 'fas fa-list'},
        ]);
    },

    methods: {
        dialogKpiPersonal(action, item) {
            this.checkError()
            this.user_update = item?.user?.id;
            this.user_name_detail = item?.user?.name;
            this.department_id = item?.department_id;
            if (!item?.user) {
                this.$message({
                    type: 'error',
                    message: 'Không tìm thấy user',
                    showClose: true
                })
                return;
            }
            let payload = {
                user_id: this.user_update,
                month: this.query.month,
                department_id: this.department_id,
            }
            this.payload = payload;

            this.$store.dispatch(GET_DATA_DETAIL_KPI, payload
            ).then((res) => {
                this.handleLink(res.data.details)
                this.dataPersonal = res.data
                this.show_score_kpi = true
                this.action = action;
            }).catch(() => {

            })
        },

        handleLink(res) {
            Object.values(res).forEach(function (item) {
                if (item.results) {
                    const urlPattern = /(https?:\/\/[^\s]+)/g;
                    item.results = item.results.replace(urlPattern, (url) => {
                        return `<a target="_blank" href="${url}" class="styled-link">${url}</a>`;
                    });
                }
            });
            return res;
        },

        search() {
            this.page = 1;
            this.getDataKpiPersonal();
        },

        clickCallback(obj) {
            this.page = obj
            this.getDataKpiPersonal();
        },

        getDataKpiPersonal() {
            this.loading = true;
            this.$store.dispatch(GET_DATA_KPI_PERSIONAL, {
                page: this.page,
                keyword: this.query.keyword,
                month: this.query.month,
                department_id: this.query.department_id,
                status: this.query.status
            }).then((res) => {
                this.dataKpiPersonal = res.data.data;
                this.totalData = res.data.total;
                this.last_page = res.data.last_page
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        checkError() {
            if (!this.query.month) {
                this.$notify.warning({
                    title: 'Thiếu dữ liệu',
                    message: `Vui lòng nhập tháng để tiếp tục`
                });

            }
        },

        getDepartmentByUserId(user_id) {
            this.$store.dispatch(GET_DEPARTMENT_BY_DEPARTMENT_HEAD, {
                user_id
            }).then((res) => {
                this.allDepartment = res.data;
            }).catch(() => {

            })
        },

        handleDialogConfirm(sum_score_week, sum_result_kip) {
            {
                if (sum_score_week) {
                    this.sum_score_week = sum_score_week;
                }
                if (sum_result_kip) {
                    this.sum_result_kip = sum_result_kip;
                }
                this.show_dialog_confirm = true
            }
        },

        getMonthCurrent() {
            let currentDate = this.$moment()
            if (currentDate.date() <= 10) {
                this.query.month = currentDate.subtract(1, 'month').format('YYYY-MM')
            } else {
                this.query.month = currentDate.format('YYYY-MM')
            }
        },

        handleAction() {
            this.show_dialog_confirm = false;
            this.show_score_kpi = false;
            this.getDataKpiPersonal()
        },

        createKra(user) {
            this.isCreateKra = true
            this.userSelected = user
        },

        showHistory(user) {
            this.isShowHistory = true
            this.userSelected = user
        }
    }
}
</script>

<style>
#JobKpiTeamlead .dialog-comfirm-score .el-dialog__body {
    padding: 1px 20px;
}
</style>


